(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4568],{

/***/ 84568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content002": function() { return /* binding */ Content002; },
  "default": function() { return /* binding */ Content002_Content002; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/cms/index.js + 3 modules
var cms = __webpack_require__(49204);
// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Content002.hook.js









var FETCH_INCREMENT = 7;
var useCollectedDataRender = function(param) {
    var payload = param.payload;
    var locale = (0,router.useRouter)().locale;
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("002", payload.id);
    var ref = (0,PageData/* useCollectedData */.M)(instanceId, [
        {
            name: "events",
            defaultValue: []
        },
        {
            name: "articles",
            defaultValue: []
        },
        {
            name: "courses",
            defaultValue: []
        }, 
    ]), events = ref.events, articles = ref.articles, courses = ref.courses;
    var ref1 = (0,react.useState)(FETCH_INCREMENT), limit = ref1[0], setLimit = ref1[1];
    //define start of each fetch
    var ref2 = (0,react.useState)(FETCH_INCREMENT), fetchStart = ref2[0], setFetchStart = ref2[1];
    var ref3;
    var eventsSlot = (ref3 = payload === null || payload === void 0 ? void 0 : payload.events) !== null && ref3 !== void 0 ? ref3 : false;
    var ref4;
    var articlesSlot = (ref4 = payload === null || payload === void 0 ? void 0 : payload.articles) !== null && ref4 !== void 0 ? ref4 : false;
    var ref5;
    var coursesSlot = (ref5 = payload === null || payload === void 0 ? void 0 : payload.programs) !== null && ref5 !== void 0 ? ref5 : false;
    var ref6;
    var promoBanners = (0,react.useMemo)(function() {
        return (ref6 = payload === null || payload === void 0 ? void 0 : payload.promoBanners) !== null && ref6 !== void 0 ? ref6 : [];
    }, [
        payload
    ]);
    var visiblePromoBanners = (0,react.useMemo)(function() {
        return promoBanners.sort(function(a, b) {
            return a.fixedPosition - b.fixedPosition;
        }).filter(function(banner) {
            return banner.fixedPosition <= limit;
        });
    }, [
        limit,
        promoBanners
    ]);
    var items = (0,react.useMemo)(function() {
        return (0,utils/* buildSortedFeed */.CT)({
            events: events,
            articles: articles,
            courses: courses
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        events,
        articles,
        courses
    ]);
    var ref7 = (0,react.useState)(items), feed = ref7[0], setFeed = ref7[1];
    var feedWithPromoBanners = (0,react.useMemo)(function() {
        return (0,utils/* mergeWithBanners */.d9)((0,_to_consumable_array/* default */.Z)(feed), visiblePromoBanners, "fixedPosition");
    }, [
        feed,
        visiblePromoBanners
    ]);
    (0,react.useEffect)(function() {
        if (feedWithPromoBanners.length <= limit) {
            var collectedDataRender = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var nextEvents, nextArticles, nextCourses, temporaryFeed;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (!eventsSlot) {
                                    _ctx.next = 6;
                                    break;
                                }
                                _ctx.next = 3;
                                return (0,cms/* fetchAPI */.I)("/events", {
                                    sort: "eventDate:ASC",
                                    populate: {
                                        previewImage: "*",
                                        eventCategories: {
                                            populate: "deep,1"
                                        }
                                    },
                                    filters: {
                                        active: {
                                            $eq: true
                                        }
                                    },
                                    pagination: {
                                        start: fetchStart,
                                        limit: FETCH_INCREMENT
                                    }
                                }, locale);
                            case 3:
                                _ctx.t0 = _ctx.sent;
                                _ctx.next = 7;
                                break;
                            case 6:
                                _ctx.t0 = {
                                    data: []
                                };
                            case 7:
                                nextEvents = _ctx.t0;
                                if (!articlesSlot) {
                                    _ctx.next = 14;
                                    break;
                                }
                                _ctx.next = 11;
                                return (0,cms/* fetchAPI */.I)("/articles", {
                                    sort: "date:DESC",
                                    populate: {
                                        articleCategories: {
                                            populate: "deep,1"
                                        },
                                        previewImage: {
                                            populate: "*"
                                        }
                                    },
                                    filters: {
                                        date: {
                                            $lte: new Date()
                                        }
                                    },
                                    pagination: {
                                        start: fetchStart * 2,
                                        limit: FETCH_INCREMENT * 2
                                    }
                                }, locale);
                            case 11:
                                _ctx.t1 = _ctx.sent;
                                _ctx.next = 15;
                                break;
                            case 14:
                                _ctx.t1 = {
                                    data: []
                                };
                            case 15:
                                nextArticles = _ctx.t1;
                                if (!coursesSlot) {
                                    _ctx.next = 22;
                                    break;
                                }
                                _ctx.next = 19;
                                return (0,cms/* fetchAPI */.I)("/courses", {
                                    populate: "deep,1",
                                    pagination: {
                                        start: fetchStart,
                                        limit: FETCH_INCREMENT
                                    }
                                }, locale);
                            case 19:
                                _ctx.t2 = _ctx.sent;
                                _ctx.next = 23;
                                break;
                            case 22:
                                _ctx.t2 = {
                                    data: []
                                };
                            case 23:
                                nextCourses = _ctx.t2;
                                temporaryFeed = (0,utils/* buildSortedFeed */.CT)({
                                    events: nextEvents === null || nextEvents === void 0 ? void 0 : nextEvents.data,
                                    articles: nextArticles === null || nextArticles === void 0 ? void 0 : nextArticles.data,
                                    courses: nextCourses === null || nextCourses === void 0 ? void 0 : nextCourses.data
                                });
                                setFeed(function(currentFeed) {
                                    return (0,_to_consumable_array/* default */.Z)(currentFeed).concat((0,_to_consumable_array/* default */.Z)(temporaryFeed));
                                });
                                setFetchStart(function(currentFetchStart) {
                                    return currentFetchStart + FETCH_INCREMENT;
                                });
                            case 27:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function collectedDataRender() {
                    return _ref.apply(this, arguments);
                };
            }();
            collectedDataRender();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        limit
    ]);
    var isCompleted = (0,react.useMemo)(function() {
        return feedWithPromoBanners.length < limit;
    }, [
        feedWithPromoBanners.length,
        limit
    ]);
    var renderNext = (0,react.useCallback)(function() {
        if (!isCompleted) {
            setLimit(function(limit) {
                return limit + FETCH_INCREMENT;
            });
        }
    }, [
        isCompleted
    ]);
    return {
        feed: feedWithPromoBanners,
        isCompleted: isCompleted,
        renderNext: renderNext,
        limit: limit
    };
};

// EXTERNAL MODULE: ./src/components/widgets/content/Content002/Content002.module.scss
var Content002_module = __webpack_require__(24746);
var Content002_module_default = /*#__PURE__*/__webpack_require__.n(Content002_module);
// EXTERNAL MODULE: ./src/components/widgets/content/Content002/Article/Article.module.scss
var Article_module = __webpack_require__(37675);
var Article_module_default = /*#__PURE__*/__webpack_require__.n(Article_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Article/Article.jsx







var DEFAULT_VISIBLE_LETTERS = 150;
var Article = function(param) {
    var item = param.item, className = param.className;
    var ref, ref1;
    var t = (0,translations/* useTranslation */.$)().t;
    var locale = (0,router.useRouter)().locale;
    var articleDate = (0,react.useMemo)(function() {
        return (0,utils/* formatDate */.p6)(item === null || item === void 0 ? void 0 : item.date, locale);
    }, [
        item === null || item === void 0 ? void 0 : item.date,
        locale
    ]);
    var truncatedDescription = (0,react.useMemo)(function() {
        var ref;
        var description = (ref = item === null || item === void 0 ? void 0 : item.description) !== null && ref !== void 0 ? ref : "";
        return (0,utils/* truncateText */.aF)(description, DEFAULT_VISIBLE_LETTERS);
    }, [
        item === null || item === void 0 ? void 0 : item.description
    ]);
    var ref2;
    var category = (ref2 = (ref = item.articleCategories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref2 !== void 0 ? ref2 : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
            directory: "news",
            slug: item.slug,
            className: (Article_module_default()).block,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Article_module_default()).card,
                children: [
                    category && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "grey",
                        uppercase: true,
                        className: (Article_module_default()).category,
                        children: t(category)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading7 */.Pb, {
                        color: "dark",
                        className: (Article_module_default()).title,
                        children: item.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "dark",
                        className: (Article_module_default()).description,
                        children: truncatedDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "grey",
                        className: (Article_module_default()).date,
                        uppercase: true,
                        children: articleDate
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Article/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content002/Banner/Banner.module.scss
var Banner_module = __webpack_require__(2151);
var Banner_module_default = /*#__PURE__*/__webpack_require__.n(Banner_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Banner/Banner.jsx






var Banner = function(param) {
    var item = param.item, className = param.className;
    var locale = (0,router.useRouter)().locale;
    var date = (0,react.useMemo)(function() {
        return (0,utils/* formatDate */.p6)(item.date, locale);
    }, [
        item.date,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
            link: item.link,
            className: (Banner_module_default()).block,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Banner_module_default()).card,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Banner_module_default()).circle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                            className: (Banner_module_default()).icon,
                            name: "arrow_right"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Banner_module_default()).date,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                className: (Banner_module_default()).calendar,
                                name: "calendar"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                color: "light",
                                children: date
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                        color: "light",
                        className: (Banner_module_default()).title,
                        children: item.title
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Banner/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content002/Course/Course.module.scss
var Course_module = __webpack_require__(7356);
var Course_module_default = /*#__PURE__*/__webpack_require__.n(Course_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Course/Course.jsx






var Course_DEFAULT_VISIBLE_LETTERS = 250;
var Course = function(param) {
    var item = param.item, className = param.className;
    var t = (0,translations/* useTranslation */.$)().t;
    var truncatedDescription = (0,react.useMemo)(function() {
        var ref;
        var description = (ref = item === null || item === void 0 ? void 0 : item.description) !== null && ref !== void 0 ? ref : "";
        return (0,utils/* truncateText */.aF)(description, Course_DEFAULT_VISIBLE_LETTERS);
    }, [
        item === null || item === void 0 ? void 0 : item.description
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
            directory: "programs",
            slug: item.slug,
            className: (Course_module_default()).block,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Course_module_default()).card,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Course_module_default()).top,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading4 */.k8, {
                                color: "light",
                                className: (Course_module_default()).title,
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                color: "light",
                                className: (Course_module_default()).description,
                                children: truncatedDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Course_module_default()).details,
                        children: [
                            (item === null || item === void 0 ? void 0 : item.courseStartDate) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                color: "light",
                                className: (Course_module_default()).date,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        className: (Course_module_default()).icon,
                                        name: "calendar"
                                    }),
                                    t("start"),
                                    " ",
                                    item.courseStartDate
                                ]
                            }),
                            (item === null || item === void 0 ? void 0 : item.coursePrice) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                color: "light",
                                className: (Course_module_default()).price,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        className: (Course_module_default()).icon,
                                        name: "tag"
                                    }),
                                    item.coursePrice
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Course/index.js


// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/components/widgets/content/Content002/Event/Event.module.scss
var Event_module = __webpack_require__(89086);
var Event_module_default = /*#__PURE__*/__webpack_require__.n(Event_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Event/Event.jsx




var Event = function(param) {
    var item = param.item, className = param.className;
    var ref, ref1;
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* PageLink */.H_, {
            directory: "events",
            slug: item.slug,
            className: (Event_module_default()).block,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                    image: item.previewImage,
                    className: (Event_module_default()).image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Event_module_default()).card,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            color: "light",
                            uppercase: true,
                            className: (Event_module_default()).category,
                            children: (ref2 = (ref = item.eventCategories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref2 !== void 0 ? ref2 : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Event_module_default()).bottom,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                                    color: "light",
                                    className: (Event_module_default()).title,
                                    children: item.title
                                }),
                                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Event_module_default()).details,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                            color: "light",
                                            className: (Event_module_default()).date,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                    className: (Event_module_default()).icon,
                                                    name: "calendar"
                                                }),
                                                item.eventTimeDescription
                                            ]
                                        }),
                                        (item === null || item === void 0 ? void 0 : item.eventPrice) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                            color: "light",
                                            className: (Event_module_default()).price,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                    className: (Event_module_default()).icon,
                                                    name: "tag"
                                                }),
                                                item.eventPrice
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Event/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/TypeCard/TypeCard.jsx





var TYPE_CARD_MAPPING = {
    banner: Banner,
    event: Event,
    article: Article,
    course: Course,
    default: Article
};
var TypeCard = function(param) {
    var className = param.className, item = param.item;
    var Card = TYPE_CARD_MAPPING[item.type] || TYPE_CARD_MAPPING.default;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
        item: item,
        className: className
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/TypeCard/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content002/Items/Items.module.scss
var Items_module = __webpack_require__(85234);
var Items_module_default = /*#__PURE__*/__webpack_require__.n(Items_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Items/Items.utils.js
var getColumnSize = function(item, index) {
    if (Boolean(item === null || item === void 0 ? void 0 : item.highlight)) {
        return "2-3";
    }
    switch(index){
        case 0:
        case 1:
            return "1-2";
        default:
            return "1-3";
    }
};
var getAdjustedColumnSize = function(item, index, rawItems) {
    var ref, ref1;
    if (Boolean(item === null || item === void 0 ? void 0 : item.highlight)) {
        return "2-3";
    }
    switch(true){
        case index === 0 && (rawItems === null || rawItems === void 0 ? void 0 : (ref = rawItems[1]) === null || ref === void 0 ? void 0 : ref.size) === "2-3":
        case index === 1 && (rawItems === null || rawItems === void 0 ? void 0 : (ref1 = rawItems[0]) === null || ref1 === void 0 ? void 0 : ref1.size) === "2-3":
            return "1-3";
        case index === 0:
        case index === 1:
            return "1-2";
        default:
            return "1-3";
    }
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Items/Items.jsx







var Items = function(param) {
    var items = param.items, limit = param.limit;
    var groupedItems = (0,react.useMemo)(function() {
        var slicedItemsCopy = items.slice(0, limit);
        var result = [];
        var groupId = 0;
        while(slicedItemsCopy.length !== 0){
            var group = slicedItemsCopy.splice(0, FETCH_INCREMENT);
            var transformedGroup = group.map(function(item, index) {
                return {
                    size: getColumnSize(item, index),
                    data: item
                };
            }).map(function(param, index, array) {
                var data = param.data, size = param.size;
                return {
                    size: getAdjustedColumnSize(data, index, array),
                    data: data
                };
            });
            result.push({
                id: groupId++,
                group: transformedGroup
            });
        }
        return result;
    }, [
        items,
        limit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Items_module_default()).items,
        children: groupedItems.map(function(param) {
            var group = param.group, id = param.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Items_module_default()).group,
                children: group.map(function(param) {
                    var size = param.size, data = param.data;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeCard, {
                        item: data,
                        className: classnames_default()((Items_module_default()).item, (Items_module_default())["size-".concat(size)])
                    }, "".concat(data.title, "_").concat(data.id));
                })
            }, id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Items/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/Content002.jsx







var Content002 = function(param) {
    var payload = param.payload;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = useCollectedDataRender({
        payload: payload
    }), feed = ref.feed, isCompleted = ref.isCompleted, renderNext = ref.renderNext, limit = ref.limit;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content002_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            className: (Content002_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Items, {
                    items: feed,
                    limit: limit
                }),
                !isCompleted && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Action */.aU, {
                    onClick: renderNext,
                    className: (Content002_module_default()).more,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Content002_module_default()).loader,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((Content002_module_default())["loader-wrapper"]),
                            children: [
                                t("lazyRendering"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    className: (Content002_module_default()).icon,
                                    name: "loader"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Content002_Content002 = (Content002);


/***/ }),

/***/ 37675:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"Article_block__RIrbi","card":"Article_card__iU_i2","category":"Article_category__sCRRa","title":"Article_title__Fy7Pp","date":"Article_date__tq5g_"};

/***/ }),

/***/ 2151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"Banner_block__XPYRj","card":"Banner_card__M3aOH","circle":"Banner_circle__HWP9N","icon":"Banner_icon___RT78","calendar":"Banner_calendar__eObYs","title":"Banner_title__tJrcN","date":"Banner_date__voI34"};

/***/ }),

/***/ 24746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content002_wrapper__NfeA5","more":"Content002_more__mVUJ6","loader":"Content002_loader__6XBTv","loader-wrapper":"Content002_loader-wrapper__Epb5Y"};

/***/ }),

/***/ 7356:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"Course_block__CUeR6","card":"Course_card___lyor","icon":"Course_icon__JponP","title":"Course_title__JFPT0","description":"Course_description__IWG_1","details":"Course_details__CrNGk","date":"Course_date__1odZS","price":"Course_price__RV05I"};

/***/ }),

/***/ 89086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"Event_block__QTEpx","image":"Event_image__p_VUK","card":"Event_card__LPTd4","category":"Event_category__mhRRF","icon":"Event_icon__hJW0J","title":"Event_title__HTi4y","details":"Event_details__frQd_","date":"Event_date__PJ8Td","price":"Event_price__sssaM"};

/***/ }),

/***/ 85234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"items":"Items_items__Xpliz","group":"Items_group__l6Cfj","item":"Items_item__FJUh1","size-1-3":"Items_size-1-3__FaPk5","size-1-2":"Items_size-1-2__CQhaV","size-2-3":"Items_size-2-3___fTiI"};

/***/ })

}]);